import * as React from 'react';
import * as JsBarcode from 'jsbarcode';

const getDOMNode = (ref) => ref;

type Props = {
  readonly value: string
  readonly format: string
  readonly width: number
  readonly height: number
  readonly displayValue: boolean
};

type States = {
};

class Barcode extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    this.update();
  }

  componentDidUpdate() {
    this.update();
  }

  render() {
   return(
    <svg ref="renderElement" />
   ); 
  }

  private update() {
    const renderElement = getDOMNode(this.refs.renderElement);
    return new JsBarcode(renderElement, this.props.value, Object.assign({}, this.props));
  }
}

export default Barcode;



// WEBPACK FOOTER //
// ./src/barcode/Barcode.tsx